import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import linkMessages from '@/client/exchanges/cacheExchange/linkMessages';
import type { ResultOf } from '@/gql/graphql';
import type { WatchNewMessagesStream } from '@/hooks/useGlobalSubscriptions';
import { setNextCursor } from '@/stores/useSubscriptionStreamStore';

export default function message_stream(
  ...vars: [
    parent: {
      message_stream: ResultOf<typeof WatchNewMessagesStream>['message_stream'];
    },
    args: any,
    cache: Cache,
    info: ResolveInfo,
  ]
) {
  const [parent, , cache] = vars;

  setNextCursor(
    'message',
    parent.message_stream[parent.message_stream.length - 1].updated_at,
  );

  linkMessages(cache, parent.message_stream);
}
